import _taggedTemplateLiteral from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
import _classCallCheck from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js";
import _possibleConstructorReturn from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _inherits from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/inherits.js";
import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8;
var __jsx = React.createElement;
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import { openModal as _openModal } from '@/redux/modal';
import { fonts, colorPalette } from '@/styles/styleGuide';
import MapboxMap, { Marker, Popup } from 'react-map-gl';
import ImageLoader from "@/components/shared/ui/ImageLoader";
import { connect } from "react-redux";
import styled from "styled-components";
import { fromBreakpoint } from '@/styles/breakpoints';
import 'mapbox-gl/dist/mapbox-gl.css';
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    openModal: function openModal(projectSlug) {
      dispatch(_openModal(colorPalette.lightOrange, {
        type: 'project',
        componentProps: {
          projectSlug: projectSlug
        }
      }));
    }
  };
};
var Map = /*#__PURE__*/function (_Component) {
  function Map() {
    var _this;
    _classCallCheck(this, Map);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, Map, [].concat(args));
    _defineProperty(_this, "state", {
      selectedMarker: null
    });
    _defineProperty(_this, "setMarker", function (e, marker) {
      _this.setState({
        selectedMarker: marker
      });
    });
    _defineProperty(_this, "openProjectModal", function () {
      _this.props.openModal(_this.state.selectedMarker.slug);
    });
    return _this;
  }
  _inherits(Map, _Component);
  return _createClass(Map, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props$markers = this.props.markers,
        markers = _this$props$markers === void 0 ? [] : _this$props$markers;
      var selectedMarker = this.state.selectedMarker;
      return __jsx(Container, {
        "data-id": "ui_Map_Container"
      }, __jsx(StyledMapboxMap, {
        mapboxAccessToken: process.env.NEXT_PUBLIC_MAPBOX_APIKEY,
        initialViewState: {
          longitude: 5.073558,
          latitude: 52.102666,
          zoom: 7.4
        },
        mapStyle: "mapbox://styles/ambv/cldc5k8l2007001ocmtjpoxyr",
        "data-id": "ui_Map_StyledMapboxMap"
      }, markers.map(function (marker) {
        return __jsx(StyledMarker, {
          key: marker.slug,
          anchor: "bottom",
          onClick: function onClick(e) {
            e.originalEvent.stopPropagation();
            _this2.setMarker(e, marker);
          },
          latitude: marker.latitude,
          longitude: marker.longitude,
          "data-id": "ui_Map_StyledMarker"
        }, __jsx("img", {
          src: "/images/marker.png",
          alt: "Marker voor een project",
          "data-id": "ui_Map_img"
        }));
      }), selectedMarker && __jsx(StyledPopup, {
        anchor: "top",
        longitude: selectedMarker.longitude,
        latitude: selectedMarker.latitude,
        onClose: function onClose(e) {
          return _this2.setMarker(e, null);
        },
        "data-id": "ui_Map_StyledPopup"
      }, __jsx(ContentWrapper, {
        "data-id": "ui_Map_ContentWrapper"
      }, __jsx(Content, {
        onClick: this.openProjectModal,
        "data-id": "ui_Map_Content"
      }, __jsx(ImageLoader, {
        mode: "img",
        src: selectedMarker.image,
        alt: selectedMarker.title,
        width: 140,
        "data-id": "ui_Map_ImageLoader"
      }), __jsx(Title, {
        "data-id": "ui_Map_Title"
      }, selectedMarker.title))))));
    }
  }]);
}(Component);
export default connect(null, mapDispatchToProps)(Map);
var Container = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  width: 100%;\n  height: 268rem;\n  ", ";\n"])), fromBreakpoint.md(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n     height: 536rem;\n  "]))));
var StyledMapboxMap = styled(MapboxMap)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  width: 100%;\n  height: 100%;\n"])));
var StyledMarker = styled(Marker)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  width: 26rem;\n  height: 26rem;\n  cursor: pointer;\n"])));
var StyledPopup = styled(Popup)(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  width: 140rem;\n\n  // Reset default styling\n  & > .mapboxgl-popup-content {\n    padding: 0;\n    box-shadow: none;\n  }\n"])));
var ContentWrapper = styled.div(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  background: #fff;\n  box-shadow: 0rem 0rem 10rem 0rem rgba(0, 0, 0, 0.25);\n  transition: box-shadow 0.15s ease-in-out;\n\n  &:hover {\n    cursor: pointer;\n    box-shadow: 0rem 0rem 10rem 0rem rgba(0, 0, 0, 0.5);\n  }\n\n  & svg {\n    position: absolute;\n    bottom: 3rem;\n    left: 50%;\n    margin-left: -10rem;\n  }\n"])));
var Content = styled.button(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  width: 100%;\n"])));
var Title = styled.p(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  margin: 12rem 0 16rem 0;\n  font-family: ", ";\n  font-size: 14rem;\n  font-weight: bold;\n  line-height: 18rem;\n  color: ", ";\n"])), fonts.primary, colorPalette.orange);